import styles from './ContactCompletedLp.module.scss'
import Link from 'next/link'
import { useRouter } from 'next/router'

const ContactCompletedLp: React.FC = () => {
  const router = useRouter()
  let buttonText
  if (router.pathname === '/lp-ui-contact-completed') {
    buttonText = 'コーポレートサイトへ'
  } else {
    buttonText = 'トップページへ戻る'
  }

  return (
    <article className={styles.main}>
      <section className={styles.content}>
        <div className={styles.title_group}>
          <div className={styles.img_container}>
            <img className={styles.img} src="/images/icons/check_icon.png" alt="" />
          </div>
          <div className={styles.text_container}>
            <h1 className={styles.title}>
              お問い合わせ
              <br className={styles.sp} />
              ありがとうございます
            </h1>
            <p className={styles.text}>お問い合わせ内容の確認メールをお送りしましたので、ご確認お願い致します。</p>
            <p className={styles.text}>また内容確認の上、弊社担当者よりメールまたはお電話にてご連絡させて頂きます。</p>
          </div>
          <div className={styles.button}>
            <Link href="/">
              <a className={styles.a}>
                {buttonText}
                <img src="/direction_white.svg" className={styles.direction_img} alt="矢印" />
              </a>
            </Link>
          </div>
        </div>
      </section>
    </article>
  )
}

export default ContactCompletedLp
